
export const countries = [
  {
    label: 'Egypt',
    value: 'egypt'
  },
  {
    label: 'Saudi Arabia',
    value: 'saudi'
  }
]

export const semesters = {
  egypt : [
    {
      label: 'First Semester',
      value: 'First Semester'
    },
    {
      label: 'Second Semester',
      value: 'Second Semester'
    }
  ],
  saudi : [
    {
      label: 'First Semester',
      value: 'First Semester'
    },
    {
      label: 'Second Semester',
      value: 'Second Semester'
    },
    {
      label: 'Third Semester',
      value: 'Third Semester'
    }
  ]
}

export const tracks = [
  {
    label: 'General Track',
    value: 'general-track'
  },
  {
    label: 'Business Administration Track',
    value: 'business-administration-track'
  },
  {
    label: 'Sharia Track',
    value: 'sharia-track'
  },
  {
    label: 'Computer Science and Engineering Track',
    value: 'computer-science-engineering-track'
  },
  {
    label: 'Health and Life Sciences Track',
    value: 'health-life-sciences-track'
  }
]

export const educationStages = [
  // المرحلة الابتدائية
  {
    label: 'Primary Stage',
    value: '',
    isDisabled: true
  },
  {
    label: 'First Grade of Primary School',
    value: 'p1'
  },
  {
    label: 'Second Grade of Primary School',
    value: 'p2'
  },
  {
    label: 'Third Grade of Primary School',
    value: 'p3'
  },
  {
    label: 'Fourth Grade of Primary School',
    value: 'p4'
  },
  {
    label: 'Fifth Grade of Primary School',
    value: 'p5'
  },
  {
    label: 'Sixth Grade of Primary School',
    value: 'p6'
  },

  // المرحلة الإعدادية
  {
    label: 'Middle School Stage',
    value: '',
    isDisabled: true
  },
  {
    label: 'First Grade of Middle School',
    value: 'm1'
  },
  {
    label: 'Second Grade of Middle School',
    value: 'm2'
  },
  {
    label: 'Third Grade of Middle School',
    value: 'm3'
  },

  // المرحلة الثانوية
  {
    label: 'High School Stage',
    value: '',
    isDisabled: true
  },
  {
    label: 'First Grade of High School',
    value: 's1'
  },
  {
    label: 'Second Grade of High School',
    value: 's2'
  },
  {
    label: 'Third Grade of High School',
    value: 's3'
  },
  
  // مرحلة الكورسات العامة
  {
    label: 'General Courses Stage',
    value: '',
    isDisabled: true
  },
  {
    label: 'General Courses',
    value: 'general'
  },
]

export const units = [
  { label: 'Unit One', value: 1 },
  { label: 'Unit Two', value: 2 },
  { label: 'Unit Three', value: 3 },
  { label: 'Unit Four', value: 4 },
  { label: 'Unit Five', value: 5 },
  { label: 'Unit Six', value: 6 },
  { label: 'Unit Seven', value: 7 },
  { label: 'Unit Eight', value: 8 },
  { label: 'Unit Nine', value: 9 },
  { label: 'Unit Ten', value: 10 },
  { label: 'Unit Eleven', value: 11 },
  { label: 'Unit Twelve', value: 12 },
  { label: 'Unit Thirteen', value: 13 },
  { label: 'Unit Fourteen', value: 14 },
  { label: 'Unit Fifteen', value: 15 }
];

const egySubjects = {
  // مواد المرحلة الابتدائية
  p1: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'اكتشف', value: 'discover' , logo : require('assets/media/Subjects/discover.png')},
    { label: 'Discover', value: 'discover-english' , logo : require('assets/media/Subjects/discover2.png')}
  ],
  p2: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'اكتشف', value: 'discover' , logo : require('assets/media/Subjects/discover.png')},
    { label: 'Discover', value: 'discover-english' , logo : require('assets/media/Subjects/discover2.png')}
  ],
  p3: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'اكتشف', value: 'discover' , logo : require('assets/media/Subjects/discover.png')},
    { label: 'Discover', value: 'discover-english' , logo : require('assets/media/Subjects/discover2.png')}
  ],
  p4: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'Science', value: 'science-english' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'الدراسات الاجتماعية', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'تكنولوجيا المعلومات والاتصالات', value: 'ict' , logo : require('assets/media/Subjects/ict.png')},
    { label: 'ICT', value: 'ict-english' , logo : require('assets/media/Subjects/ict2.png')}
  ],
  p5: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'Science', value: 'science-english' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'الدراسات الاجتماعية', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'تكنولوجيا المعلومات والاتصالات', value: 'ict' , logo : require('assets/media/Subjects/ict.png')},
    { label: 'ICT', value: 'ict-english' , logo : require('assets/media/Subjects/ict2.png')}
  ],
  p6: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'Science', value: 'science-english' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'الدراسات الاجتماعية', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'تكنولوجيا المعلومات والاتصالات', value: 'ict' , logo : require('assets/media/Subjects/ict.png')},
    { label: 'ICT', value: 'ict-english' , logo : require('assets/media/Subjects/ict2.png')}
  ],

  // مواد المرحلة الإعدادية
  m1: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'Français', value: 'french' , logo : require('assets/media/Subjects/french.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'Science', value: 'science-english' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'الدراسات الاجتماعية', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')}
  ],
  m2: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'Science', value: 'science-english' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'الدراسات الاجتماعية', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')}
  ],
  m3: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'Science', value: 'science-english' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'الدراسات الاجتماعية', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')}
  ],

  // مواد المرحلة الثانوية
  s1: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'Français', value: 'french' , logo : require('assets/media/Subjects/french.png')},
    { label: 'Deutsch', value: 'german' , logo : require('assets/media/Subjects/german.png')},
    { label: 'Italiano', value: 'italian' , logo : require('assets/media/Subjects/italian.png')},
    { label: 'Español', value: 'spanish' , logo : require('assets/media/Subjects/spanish.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'الفيزياء', value: 'physics' , logo : require('assets/media/Subjects/physics.png')},
    { label: 'Physics', value: 'physics-english' , logo : require('assets/media/Subjects/physics2.png')},
    { label: 'الكيمياء', value: 'chemistry' , logo : require('assets/media/Subjects/chemistry.png')},
    { label: 'Chemistry', value: 'chemistry-english' , logo : require('assets/media/Subjects/chemistry2.png')},
    { label: 'الأحياء', value: 'biology' , logo : require('assets/media/Subjects/biology.png')},
    { label: 'Biology', value: 'biology-english' , logo : require('assets/media/Subjects/biology2.png')},
    { label: 'التاريخ', value: 'history' , logo : require('assets/media/Subjects/history.png')},
    { label: 'الفلسفة', value: 'philosophy' , logo : require('assets/media/Subjects/philosophy.png')},
    { label: 'الفلسفة والمنطق', value: 'philosophy-logic' , logo : require('assets/media/Subjects/philosophy2.png')},
    { label: 'Integrated Science', value: 'integrated-science' , logo : require('assets/media/Subjects/science3.png')},
    { label: 'العلوم المتكاملة', value: 'integrated-science-arabic' , logo : require('assets/media/Subjects/science4.png')}
  ],
  s2: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'Français', value: 'french' , logo : require('assets/media/Subjects/french.png')},
    { label: 'Deutsch', value: 'german' , logo : require('assets/media/Subjects/german.png')},
    { label: 'Italiano', value: 'italian' , logo : require('assets/media/Subjects/italian.png')},
    { label: 'Español', value: 'spanish' , logo : require('assets/media/Subjects/spanish.png')},
    { label: 'الرياضيات العامة', value: 'general-mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'General Mathematics', value: 'general-mathematics-english' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'الرياضيات البحتة', value: 'pure-mathematics' , logo : require('assets/media/Subjects/maths2.png')},
    { label: 'Pure Mathematics', value: 'pure-mathematics-english' , logo : require('assets/media/Subjects/maths3.png')},
    { label: 'تطبيقات الرياضيات', value: 'mathematics-applications' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics Applications', value: 'mathematics-applications-english' , logo : require('assets/media/Subjects/maths2.png')},
    { label: 'الفيزياء', value: 'physics' , logo : require('assets/media/Subjects/physics.png')},
    { label: 'Physics', value: 'physics-english' , logo : require('assets/media/Subjects/physics2.png')},
    { label: 'الكيمياء', value: 'chemistry' , logo : require('assets/media/Subjects/chemistry.png')},
    { label: 'Chemistry', value: 'chemistry-english' , logo : require('assets/media/Subjects/chemistry2.png')},
    { label: 'الأحياء', value: 'biology' , logo : require('assets/media/Subjects/biology.png')},
    { label: 'Biology', value: 'biology-english' , logo : require('assets/media/Subjects/biology2.png')},
    { label: 'التاريخ', value: 'history' , logo : require('assets/media/Subjects/history.png')},
    { label: 'الجغرافيا', value: 'geography' , logo : require('assets/media/Subjects/geography.png')},
    { label: 'علم النفس والاجتماع', value: 'psychology-and-sociology' , logo : require('assets/media/Subjects/philosophy.png')}
  ],
  s3: [
    { label: 'اللغة العربية', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'English', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'Français', value: 'french' , logo : require('assets/media/Subjects/french.png')},
    { label: 'Deutsch', value: 'german' , logo : require('assets/media/Subjects/german.png')},
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'Mathematics', value: 'mathematics-english' , logo : require('assets/media/Subjects/maths2.png')},
    { label: 'الفيزياء', value: 'physics' , logo : require('assets/media/Subjects/physics.png')},
    { label: 'Physics', value: 'physics-english' , logo : require('assets/media/Subjects/physics2.png')},
    { label: 'الكيمياء', value: 'chemistry' , logo : require('assets/media/Subjects/chemistry.png')},
    { label: 'Chemistry', value: 'chemistry-english' , logo : require('assets/media/Subjects/chemistry2.png')},
    { label: 'الأحياء', value: 'biology' , logo : require('assets/media/Subjects/biology.png')},
    { label: 'Biology', value: 'biology-english' , logo : require('assets/media/Subjects/biology2.png')},
    { label: 'التاريخ', value: 'history' , logo : require('assets/media/Subjects/history.png')},
    { label: 'الجغرافيا', value: 'geography' , logo : require('assets/media/Subjects/geography.png')},
    { label: 'الإحصاء', value: 'statistics' , logo : require('assets/media/Subjects/statistics.png')},
    { label: 'Statistics', value: 'statistics-english' , logo : require('assets/media/Subjects/statistics2.png')}
  ]
}

const saudiaSubjects = {
  // مواد المرحلة الابتدائية
  p1: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'الحياتية والاسرية', value: 'life-family' , logo : require('assets/media/Subjects/family.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  p2: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths3.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  p3: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths2.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  p4: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science4.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الإجتماعيات', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'المهارات الرقمية', value: 'digital-skills' , logo : require('assets/media/Subjects/ict2.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  p5: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science4.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الإجتماعيات', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'المهارات الرقمية', value: 'digital-skills' , logo : require('assets/media/Subjects/ict2.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  p6: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science4.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الإجتماعيات', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'المهارات الرقمية', value: 'digital-skills' , logo : require('assets/media/Subjects/ict2.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],

  // مواد المرحلة الإعدادية
  m1: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science3.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الإجتماعيات', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'المهارات الرقمية', value: 'digital-skills' , logo : require('assets/media/Subjects/ict.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  m2: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/maths2.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science2.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الإجتماعيات', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'المهارات الرقمية', value: 'digital-skills' , logo : require('assets/media/Subjects/ict.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],
  m3: [
    { label: 'الرياضيات', value: 'mathematics' , logo : require('assets/media/Subjects/mathematics.png')},
    { label: 'التفكير الناقد', value: 'critical-thinking' , logo : require('assets/media/Subjects/thinking.png')},
    { label: 'العلوم', value: 'science' , logo : require('assets/media/Subjects/science4.png')},
    { label: 'لغتي', value: 'arabic' , logo : require('assets/media/Subjects/arabic.png')},
    { label: 'انجليزي', value: 'english' , logo : require('assets/media/Subjects/english.png')},
    { label: 'الإجتماعيات', value: 'social-studies' , logo : require('assets/media/Subjects/socialStudies.png')},
    { label: 'مواد التربية الاسلامية', value: 'religion' , logo : require('assets/media/Subjects/religion.png')},
    { label: 'المهارات الحياتية', value: 'life-skills' , logo : require('assets/media/Subjects/life.png')},
    { label: 'المهارات الرقمية', value: 'digital-skills' , logo : require('assets/media/Subjects/ict.png')},
    { label: 'الفنية', value: 'art' , logo : require('assets/media/Subjects/art.png')}
  ],

  // مواد المرحلة الثانوية
  s1: [
    { label: 'اللغة العربية 1', value: 'arabic-1' , logo : require('assets/media/Subjects/arabic2.png')},
    { label: 'الرياضيات 1', value: 'mathematics-1' , logo : require('assets/media/Subjects/maths2.png')},
    { label: 'التفسير 1', value: 'Monotheism-1' , logo : require('assets/media/Subjects/religion2.png')},
    { label: 'الأحياء 1', value: 'biology-1' , logo : require('assets/media/Subjects/biology2.png')},
    { label: 'انجليزي 1', value: 'english-1' , logo : require('assets/media/Subjects/english2.png')},
    { label: 'التفكير الناقد 1', value: 'critical-thinking-1' , logo : require('assets/media/Subjects/thinking.png')},
    { label: 'التقنية الرقمية 1', value: 'digital-technology-1' , logo : require('assets/media/Subjects/ict.png')}
  ],
  'general-track': {
    s2: [
      { label: 'التوحيد 1', value: 'Monotheism-1' , logo : require('assets/media/Subjects/religion3.png')},
      { label: 'الرياضيات 2', value: 'mathematics-2' , logo : require('assets/media/Subjects/maths3.png')},
      { label: 'انجليزي 2', value: 'english-2' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الكيمياء 2', value: 'chemistry-2' , logo : require('assets/media/Subjects/chemistry2.png')},
      { label: 'الأحياء 2', value: 'biology-2' , logo : require('assets/media/Subjects/biology2.png')},
      { label: 'الفنون', value: 'art' , logo : require('assets/media/Subjects/art.png')},
      { label: 'اللياقة والثقافة الصحية', value: 'health' , logo : require('assets/media/Subjects/health.png')}
    ],
    s3: [
      { label: 'الرياضيات 3', value: 'mathematics-3' , logo : require('assets/media/Subjects/mathematics.png')},
      { label: 'الفيزياء 3', value: 'physics-3' , logo : require('assets/media/Subjects/physics2.png')},
      { label: 'الكيمياء 3', value: 'chemistry-3' , logo : require('assets/media/Subjects/chemistry2.png')},
      { label: 'انجليزي 3', value: 'english-3' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'البحث ومصادر المعلومات', value: 'search-learn' , logo : require('assets/media/Subjects/search.png')},
      { label: 'التقنية الرقمية 3', value: 'digital-technology-3' , logo : require('assets/media/Subjects/ict2.png')},
      { label: 'التصمبم الرقمي 3', value: 'digital-design-3' , logo : require('assets/media/Subjects/ict.png')},
      { label: 'التنمية المستدامة', value: 'development' , logo : require('assets/media/Subjects/development.png')},
      { label: 'الجغرافيا', value: 'geographic' , logo : require('assets/media/Subjects/geography.png')},
      { label: 'المهارات الادارية', value: 'administrative-skills' , logo : require('assets/media/Subjects/administrative.png')},
      { label: 'الكتابة الوظيفية والإبداعية', value: 'writing' , logo : require('assets/media/Subjects/writing.png')},
      { label: 'هيا نتعلم الصينية', value: 'chinese' , logo : require('assets/media/Subjects/chinese.png')}
    ]
  },
  'business-administration-track': {
    s2: [
      { label: 'التوحيد 1', value: 'Monotheism-1' , logo : require('assets/media/Subjects/religion3.png')},
      { label: 'اللغة العربية 2', value: 'arabic-2' , logo : require('assets/media/Subjects/arabic2.png')},
      { label: 'انجليزي 2', value: 'english-2' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'مبادئ الاقتصاد', value: 'economy' , logo : require('assets/media/Subjects/economy.png')},
      { label: 'مقدمة في الاعمال', value: 'business' , logo : require('assets/media/Subjects/business.png')},
      { label: 'صناعة القرار في الاعمال', value: 'business-decision' , logo : require('assets/media/Subjects/businessDecision.png')},
      { label: 'اللياقة والثقافة الصحية', value: 'health' , logo : require('assets/media/Subjects/health.png')}
    ],
    s3: [
      { label: 'الإحصاء', value: 'statistic' , logo : require('assets/media/Subjects/statistics2.png')},
      { label: 'تخطيط الحملات التسويقية', value: 'marketing' , logo : require('assets/media/Subjects/marketing.png')},
      { label: 'البحث ومصادر المعلومات', value: 'search-learn' , logo : require('assets/media/Subjects/search.png')},
      { label: 'انجليزي 3', value: 'english-3' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الفقة 1', value: 'Jurisprudence' , logo : require('assets/media/Subjects/religion2.png')},
      { label: 'مبادئ القانون', value: 'law' , logo : require('assets/media/Subjects/law.png')},
      { label: 'الدراسات البلاغية والنقدية', value: 'arabic-3' , logo : require('assets/media/Subjects/arabic2.png')},
      { label: 'الجغرافيا', value: 'geographic' , logo : require('assets/media/Subjects/geography.png')}
    ]
  },
  'sharia-track': {
    s2: [
      { label: 'التوحيد 1', value: 'Monotheism-1' , logo : require('assets/media/Subjects/religion2.png')},
      { label: 'انجليزي 2', value: 'english-2' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'اللغة العربية 2', value: 'arabic-2' , logo : require('assets/media/Subjects/arabic2.png')},
      { label: 'التقنية الرقمية 2', value: 'digital-technology-2' , logo : require('assets/media/Subjects/ict2.png')},
      { label: 'اللياقة والثقافة الصحية', value: 'health' , logo : require('assets/media/Subjects/health.png')}
    ],
    s3: [
      { label: 'الفقة 1', value: 'Jurisprudence' , logo : require('assets/media/Subjects/religion3.png')},
      { label: 'مصطلح الحديث', value: 'term' , logo : require('assets/media/Subjects/religion4.png')},
      { label: 'مبادئ القانون', value: 'law' , logo : require('assets/media/Subjects/law.png')},
      { label: 'الدراسات البلاغية والنقدية', value: 'arabic-3' , logo : require('assets/media/Subjects/arabic2.png')},
      { label: 'البحث ومصادر المعلومات', value: 'search-learn' , logo : require('assets/media/Subjects/search.png')},
      { label: 'انجليزي 3', value: 'english-3' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الجغرافيا', value: 'geographic' , logo : require('assets/media/Subjects/geography.png')}
    ]
  },
  'computer-science-engineering-track': {
    s2: [
      { label: 'التوحيد 1', value: 'Monotheism-1' , logo : require('assets/media/Subjects/religion2.png')},
      { label: 'انجليزي 2', value: 'english-2' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الرياضيات 2', value: 'mathematics-2' , logo : require('assets/media/Subjects/maths2.png')},
      { label: 'الكيمياء 2', value: 'chemistry-2' , logo : require('assets/media/Subjects/chemistry2.png')},
      { label: 'الأحياء 2', value: 'biology-2' , logo : require('assets/media/Subjects/biology2.png')},
      { label: 'علم البيانات', value: 'data-science' , logo : require('assets/media/Subjects/dataScience.png')},
      { label: 'الهندسة', value: 'eng' , logo : require('assets/media/Subjects/eng.png')}
    ],
    s3: [
      { label: 'هندسة البرمجيات', value: 'eng' , logo : require('assets/media/Subjects/eng.png')},
      { label: 'الذكاء الإصطناعي', value: 'ai' , logo : require('assets/media/Subjects/ai.png')},
      { label: 'البحث ومصادر المعلومات', value: 'search-learn' , logo : require('assets/media/Subjects/search.png')},
      { label: 'الرياضيات 3', value: 'mathematics-3' , logo : require('assets/media/Subjects/maths3.png')},
      { label: 'الكيمياء 3', value: 'chemistry-3' , logo : require('assets/media/Subjects/chemistry2.png')},
      { label: 'انجليزي 3', value: 'english-3' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الفيزياء 3', value: 'physics-3' , logo : require('assets/media/Subjects/physics2.png')}
    ]
  },
  'health-life-sciences-track': {
    s2: [
      { label: 'التوحيد 1', value: 'Monotheism-1' , logo : require('assets/media/Subjects/religion3.png')},
      { label: 'انجليزي 2', value: 'english-2' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الرياضيات 2', value: 'mathematics-2' , logo : require('assets/media/Subjects/maths3.png')},
      { label: 'الكيمياء 2', value: 'chemistry-2' , logo : require('assets/media/Subjects/chemistry2.png')},
      { label: 'الأحياء 2', value: 'biology-2' , logo : require('assets/media/Subjects/biology2.png')},
      { label: 'التقنية الرقمية 2', value: 'digital-technology-2' , logo : require('assets/media/Subjects/ict2.png')},
      { label: 'اللياقة والثقافة الصحية', value: 'health' , logo : require('assets/media/Subjects/health.png')}
    ],
    s3: [
      { label: 'الرعاية الصحية', value: 'health-care' , logo : require('assets/media/Subjects/health.png')},
      { label: 'أنظمة جسم الإنسان', value: 'human-body' , logo : require('assets/media/Subjects/biology.png')},
      { label: 'البحث ومصادر المعلومات', value: 'search-learn' , logo : require('assets/media/Subjects/search.png')},
      { label: 'الرياضيات 3', value: 'mathematics-3' , logo : require('assets/media/Subjects/maths2.png')},
      { label: 'الكيمياء 3', value: 'chemistry-3' , logo : require('assets/media/Subjects/chemistry2.png')},
      { label: 'انجليزي 3', value: 'english-3' , logo : require('assets/media/Subjects/english2.png')},
      { label: 'الفيزياء 3', value: 'physics-3' , logo : require('assets/media/Subjects/physics2.png') }
    ]
  }
}

export const subjects = {
  egypt: egySubjects,
  saudi : saudiaSubjects
}